import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { FaCheck } from "react-icons/fa";

const FundingLabWelcomeArea = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id") || "";

  // loading | paid | unpaid | error
  const [status, setStatus] = useState("loading");
  const [details, setDetails] = useState(null);

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }

    let cancelled = false;

    fetch(`/api/checkout-session.php?session_id=${encodeURIComponent(sessionId)}`)
      .then(async (res) => {
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.error || "Could not verify your payment.");
        if (cancelled) return;
        setDetails(data);
        setStatus(data.payment_status === "paid" ? "paid" : "unpaid");
      })
      .catch(() => {
        if (!cancelled) setStatus("error");
      });

    return () => {
      cancelled = true;
    };
  }, [sessionId]);

  return (
    <div className="service-area pd-bottom-90 funding-lab-v2">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-7 col-12">
            <div className="fl2-section text-center">
              {status === "loading" && <p className="fl2-section-kicker">Confirming your payment…</p>}

              {status === "paid" && (
                <>
                  <div className="fl2-modal-success-badge" style={{ margin: "0 auto 18px" }}>
                    <FaCheck />
                  </div>
                  <h1 className="fl2-section-title">You're enrolled!</h1>
                  <p className="fl2-section-kicker">
                    Thanks{details?.customer_email ? ` — we've sent a receipt to ${details.customer_email}` : ""}.
                    Your seat in Funding Lab is confirmed.
                  </p>
                  <ul className="fl2-check-list text-start">
                    <li className="fl2-check-item">
                      <span className="fl2-check-badge"><FaCheck /></span>
                      <span>Your cohort starts September 18, 2026 and runs through November 28.</span>
                    </li>
                    <li className="fl2-check-item">
                      <span className="fl2-check-badge"><FaCheck /></span>
                      <span>The Evolvelab team will email you directly with onboarding details and next steps.</span>
                    </li>
                    <li className="fl2-check-item">
                      <span className="fl2-check-badge"><FaCheck /></span>
                      <span>Questions in the meantime? <Link to="/contact">Contact us</Link>.</span>
                    </li>
                  </ul>
                </>
              )}

              {status === "unpaid" && (
                <>
                  <h1 className="fl2-section-title">Payment not completed</h1>
                  <p className="fl2-section-kicker">
                    It looks like this checkout wasn't completed. No charge was made.
                  </p>
                  <Link to="/fundinglab/enroll" className="fl2-btn fl2-btn-solid fl2-btn-lg">
                    Try again
                  </Link>
                </>
              )}

              {status === "error" && (
                <>
                  <h1 className="fl2-section-title">We couldn't confirm this payment</h1>
                  <p className="fl2-section-kicker">
                    If you were just charged, don't worry — we'll still receive your payment
                    confirmation. If you're not sure, <Link to="/contact">contact us</Link> and we'll
                    sort it out.
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FundingLabWelcomeArea;
